import { useState, useEffect } from 'react';
import { networkService } from '../services';
import { useAppDispatch } from '../store/hooks';

/**
 * Hook to access and monitor network status
 * 
 * @returns An object containing:
 *   - isOnline: current online status
 *   - testConnection: function to test connection to a specific endpoint
 */
export const useNetworkStatus = () => {
  const [isOnline, setIsOnline] = useState<boolean>(networkService.isOnline());
  const dispatch = useAppDispatch();
  
  useEffect(() => {
    // Initialize the service with Redux dispatch
    networkService.initialize(dispatch);
    
    // Set up a listener for status changes
    const unsubscribe = networkService.addListener((status) => {
      setIsOnline(status);
    });
    
    // Clean up
    return unsubscribe;
  }, [dispatch]);
  
  // Function to manually test connection
  const testConnection = async (url?: string) => {
    return await networkService.testConnection(url);
  };
  
  return {
    isOnline,
    testConnection
  };
};

export default useNetworkStatus;